import React from 'react';
import dynamic from 'next/dynamic';
import GlobalModalSpin from '../components/Global/Modal/ModalSpin';

const dynamicLoaderOptions = {
  loading: () => <GlobalModalSpin />,
};

const AddFamilyHealthHistoryComponent = dynamic(
  () => import('../components/Patients/AddFamilyHealthHistory'),
  dynamicLoaderOptions,
);

const AddAllergyComponent = dynamic(
  () => import('../components/Patients/AddAllergy'),
  dynamicLoaderOptions,
);

const AddDiagnosticImagingComponent = dynamic(
  () => import('../components/Patients/AddDiagnosticImagingOrder'),
  dynamicLoaderOptions,
);

const AddProvidersToFacilityComponent = dynamic(
  () => import('../components/Admin/Facilities/AddProvidersToFacility'),
  dynamicLoaderOptions,
);

const AddImmunizationComponent = dynamic(
  () => import('../components/Patients/AddImmunization'),
  dynamicLoaderOptions,
);

const AddLaboratoryOrderComponent = dynamic(
  () => import('../components/Patients/AddLaboratoryOrder'),
  dynamicLoaderOptions,
);

const AddLaboratoryResultComponent = dynamic(
  () => import('../components/Patients/AddLaboratoryResult'),
  dynamicLoaderOptions,
);

const AddLeaveComponent = dynamic(
  () => import('../components/Calendar/AddLeave'),
  dynamicLoaderOptions,
);

const AddMedicationComponent = dynamic(
  () => import('../components/Patients/AddMedication'),
  dynamicLoaderOptions,
);

const AddObservationComponent = dynamic(
  () => import('../components/Patients/AddObservation'),
  dynamicLoaderOptions,
);

const AddPatientComponent = dynamic(
  () => import('../components/Patients/AddPatient'),
  dynamicLoaderOptions,
);

const AddPatientScheduleComponent = dynamic(
  () => import('../components/Patients/AddPatientSchedule'),
  dynamicLoaderOptions,
);

const AddProblemComponent = dynamic(
  () => import('../components/Patients/AddProblem'),
  dynamicLoaderOptions,
);

const AddRoundingWorkShiftsComponent = dynamic(
  () => import('../components/Calendar/AddRoundingWorkShifts'),
  dynamicLoaderOptions,
);

const AddTelemedWorkShiftsComponent = dynamic(
  () => import('../components/Calendar/AddTelemedWorkShifts'),
  dynamicLoaderOptions,
);

const AddWoundWorkShiftsComponent = dynamic(
  () => import('../components/Calendar/AddWoundWorkShifts'),
  dynamicLoaderOptions,
);

const AddImplantableDevice = dynamic(
  () => import('../components/Patients/AddImplantableDevice'),
  dynamicLoaderOptions,
);

const CdsIframeComponent = dynamic(
  () => import('../components/Provider/CdsIframe'),
  dynamicLoaderOptions,
);

const D2cPatientScheduleCallComponent = dynamic(
  () => import('../components/Calendar/D2cPatientScheduleCall'),
  dynamicLoaderOptions,
);

const ManageExternalMapsComponent = dynamic(
  () => import('../components/Admin/TechnicalSettings/Jobs/ManageExternalMaps'),
  dynamicLoaderOptions,
);

const SwitchRoleComponent = dynamic(
  () => import('../components/common/SwitchRole'),
  dynamicLoaderOptions,
);

const UpdateAllergyComponent = dynamic(
  () => import('../components/Patients/UpdateAllergy'),
  dynamicLoaderOptions,
);

const UpdateDiagnosticImagingOrder = dynamic(
  () => import('../components/Patients/UpdateDiagnosticImagingOrder'),
  dynamicLoaderOptions,
);

const UpdateImmunizationComponent = dynamic(
  () => import('../components/Patients/UpdateImmunization'),
  dynamicLoaderOptions,
);

const UpdateFamilyHealthHistoryComponent = dynamic(
  () => import('../components/Patients/UpdateFamilyHealthHistory'),
  dynamicLoaderOptions,
);

const UpdateLaboratoryOrderComponent = dynamic(
  () => import('../components/Patients/UpdateLaboratoryOrder'),
  dynamicLoaderOptions,
);

const UpdateLaboratoryResultComponent = dynamic(
  () => import('../components/Patients/UpdateLaboratoryResult'),
  dynamicLoaderOptions,
);

const UpdateMedicationComponent = dynamic(
  () => import('../components/Patients/UpdateMedication'),
  dynamicLoaderOptions,
);

const UpdatePatientCareInfoComponent = dynamic(
  () => import('../components/Patients/UpdatePatientCareInfo'),
  dynamicLoaderOptions,
);

const UpdatePatientContactComponent = dynamic(
  () => import('../components/Patients/UpdatePatientContact'),
  dynamicLoaderOptions,
);

const UpdatePatientDemographicsComponent = dynamic(
  () => import('../components/Patients/UpdatePatientDemographics'),
  dynamicLoaderOptions,
);

const UpdateRoundingWorkShiftComponent = dynamic(
  () => import('../components/Calendar/UpdateRoundingWorkShift'),
  dynamicLoaderOptions,
);

const UpdateTelemedWorkShiftComponent = dynamic(
  () => import('../components/Calendar/UpdateTelemedWorkShift'),
  dynamicLoaderOptions,
);

const UpdateWoundWorkShiftComponent = dynamic(
  () => import('../components/Calendar/UpdateWoundWorkShift'),
  dynamicLoaderOptions,
);

const UpdateImplantableDevice = dynamic(
  () => import('../components/Patients/UpdateImplantableDevice'),
  dynamicLoaderOptions,
);

const UpdateLeaveComponent = dynamic(
  () => import('../components/Calendar/UpdateLeave'),
  dynamicLoaderOptions,
);

const UpdateProblemComponent = dynamic(
  () => import('../components/Patients/UpdateProblem'),
  dynamicLoaderOptions,
);

const UpdateSystemSettings = dynamic(
  () => import('../components/Admin/TechnicalSettings/SystemSettings/UpdateSystemSettings'),
  dynamicLoaderOptions,
);

const UpdatePatientScheduleComponent = dynamic(
  () => import('../components/Patients/UpdatePatientSchedule'),
  dynamicLoaderOptions,
);

export default {
  addFamilyHealthHistory: AddFamilyHealthHistoryComponent,
  addAllergy: AddAllergyComponent,
  addDiagnosticImagingOrder: AddDiagnosticImagingComponent,
  addProvidersToFacility: AddProvidersToFacilityComponent,
  addImmunization: AddImmunizationComponent,
  addMedication: AddMedicationComponent,
  addLeave: AddLeaveComponent,
  addLaboratoryOrder: AddLaboratoryOrderComponent,
  addLaboratoryResult: AddLaboratoryResultComponent,
  addObservation: AddObservationComponent,
  addPatient: AddPatientComponent,
  addPatientSchedule: AddPatientScheduleComponent,
  addProblem: AddProblemComponent,
  addRoundingWorkShifts: AddRoundingWorkShiftsComponent,
  addTelemedWorkShifts: AddTelemedWorkShiftsComponent,
  addWoundWorkShifts: AddWoundWorkShiftsComponent,
  addImplantableDevice: AddImplantableDevice,
  cdsIframe: CdsIframeComponent,
  d2cPatientScheduleCall: D2cPatientScheduleCallComponent,
  manageExternalMaps: ManageExternalMapsComponent,
  switchRole: SwitchRoleComponent,
  updateAllergy: UpdateAllergyComponent,
  updateDiagnosticImagingOrder: UpdateDiagnosticImagingOrder,
  updateFamilyHealthHistory: UpdateFamilyHealthHistoryComponent,
  updateImmunization: UpdateImmunizationComponent,
  updateLaboratoryOrder: UpdateLaboratoryOrderComponent,
  updateLaboratoryResult: UpdateLaboratoryResultComponent,
  updateLeave: UpdateLeaveComponent,
  updateMedication: UpdateMedicationComponent,
  updatePatientCareInfo: UpdatePatientCareInfoComponent,
  updatePatientContact: UpdatePatientContactComponent,
  updatePatientDemographics: UpdatePatientDemographicsComponent,
  updateRoundingWorkShift: UpdateRoundingWorkShiftComponent,
  updateTelemedWorkShift: UpdateTelemedWorkShiftComponent,
  updateWoundWorkShift: UpdateWoundWorkShiftComponent,
  updateImplantableDevice: UpdateImplantableDevice,
  updateProblem: UpdateProblemComponent,
  updateSystemSettings: UpdateSystemSettings,
  updatePatientSchedule: UpdatePatientScheduleComponent,
};
